import { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { FaxTypes } from '@frontend/api-fax-legacy';
import { FaxFilters } from '../components/fax-history/fax-filters';
import { FaxHistoryTable } from '../components/fax-history/fax-history-table';

export const FaxHistory = () => {
  const [filters, setFilters] = useState<FaxTypes.FaxFilters>({
    dateRange: [dayjs(new Date()).add(-7, 'day').format('MM/DD/YYYY'), dayjs(new Date()).format('MM/DD/YYYY')],
    recipientNumber: '',
    senderNumber: '',
  });

  const filterQueryString = useMemo(() => {
    const { dateRange, recipientNumber, senderNumber } = filters;
    const startDate = dateRange?.[0];
    const endDate = dateRange?.[1];

    return `?recipient=${recipientNumber}&sender=${senderNumber}&start=${
      startDate ? dayjs(startDate).format('MM-DD-YYYY') : ''
    }&end=${endDate ? dayjs(endDate).format('MM-DD-YYYY') : ''}`;
  }, [filters]);

  return (
    <section>
      <FaxFilters filters={filters} onChange={setFilters} query={filterQueryString} />
      <FaxHistoryTable query={filterQueryString} />
    </section>
  );
};
